import { useDataValue } from 'Simple/Data'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let location_id = useDataValue({
    context: 'selected',
    path: 'location_id',
    viewPath: props.viewPath,
  })
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onSubmit({ value, originalValue, args, change }) {
    if (!value.name || !value.description) return true

    let mutationResponse = await executeMutation({
      object: {
        name: value.name,
        description: value.description,
        requires_diagnosis: value.requires_diagnosis,
        requires_images: value.requires_images,
        procedure_misc_fee_charge_templates: {
          data: value.charge_ids.map(misc_fee_charge_template_id => ({
            misc_fee_charge_template_id,
          })),
        },
        organization_id: location_id,
      },
    })
    if (mutationResponse.error) {
      notify(notifyError(`An error has occurred while inserting procedure.`))
      return
    }

    notify(notifySuccess(`New procedure has been added.`))

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
